import { GetConfirmedQc } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface ConfirmedQcParam {
  rmaNo: string;
}

const endPoint = 'confirmed-qc';

export const fetchConfirmedQc = async (
  params: ConfirmedQcParam,
): Promise<GetConfirmedQc> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
